import * as z from 'zod';

export const DomesticHotWaterSchema = z.object({
  system: z.string().optional(),
});

export type DomesticHotWater = z.infer<typeof DomesticHotWaterSchema>;
